import {
    CREATE_UOM,
    DELETE_UOM,
    GET_UOMS_STRUCTURE,
    GET_UOMS,
    UOM_REQUEST_FAILURE,
    UOM_REQUEST,
    UPDATE_UOM
} from '../types';

const initialState = {
    states: []
};

const stateReducer = (state = initialState, action) => {
    switch (action.type) {
        case UOM_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_UOMS:
            return {
                ...state,
                uoms: action.payload,
            };
        case GET_UOMS_STRUCTURE: {
            return {
                ...state,
                stateStructure: [...action.payload],
                loading: false,
                error: null
            }
        }
        case CREATE_UOM:
            return {
                ...state,
                uoms: [action.payload, ...state.uoms],
                loading: false,
                error: null
            };
        case UPDATE_UOM:
            const uomsData = state.uoms.slice(0);
            const uIndex = uomsData.findIndex((data) => data.id === action.payload.id);
            uomsData.splice(uIndex, 1, { ...action.payload.data });
            return {
                ...state,
                uoms: [ ...uomsData ],
                loading: false,
                error: null
            };
        case DELETE_UOM:
            const uoms = state.uoms?.slice(0);
            const index = uoms.findIndex((data) => data.id === action.id);
            if (index > -1) {
                uoms.splice(index, 1);
            }
            return {
                ...state,
                uoms: [...uoms],
                loading: false,
                error: null
            }
        case UOM_REQUEST_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            }
        }
        default:
            return state;
    }
};

export default stateReducer;
